<template>
  <div class="settings-container">
    <CardIeaAppMain colorCard="transparent" title="" class="premium-wrapper">
      <v-col cols="12" class="pa-0">
        
        <!-- Hero Header -->
        <div class="hero-header glass-panel mb-4 py-3 px-6 mx-4 mt-4">
          <div class="d-flex align-center justify-space-between w-100 flex-wrap">
            <div class="d-flex align-center mb-2 mb-md-0">
              <v-btn icon dark color="primary" class="mr-4 glass-btn" @click="$router.go(-1)">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <div>
                <h1 class="text-h5 font-weight-bold primary-text mb-0">{{ title }}</h1>
                <p class="text-caption grey--text text--darken-1 mb-0">Gestiona tu privacidad y preferencias del portal</p>
              </div>
            </div>
            <v-icon size="48" color="primary" class="opacity-30 d-none d-sm-block">mdi-cog-outline</v-icon>
          </div>
        </div>

        <div class="mx-4 mb-8">
          <v-row>
            <!-- Columna Principal: Privacidad y Perfil Público -->
            <v-col cols="12" md="6">
              <v-card class="glass-card rounded-xl h-100 mb-4 mb-md-0" elevation="10">
                <div class="pa-6">
                  <div class="d-flex align-center mb-6">
                    <v-icon color="primary" class="mr-3">mdi-shield-account-outline</v-icon>
                    <h2 class="text-h6 font-weight-bold primary-text mb-0">Perfil Público</h2>
                  </div>
                  
                  <v-list class="transparent-bg pa-0">
                    <v-list-item class="px-0 hover-bg rounded-lg transition-all mb-2">
                      <v-list-item-avatar class="primary-light-bg rounded-lg">
                        <v-icon color="primary">mdi-text-account</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium primary-text">Mostrar Biografía</v-list-item-title>
                        <v-list-item-subtitle class="text-caption grey--text">Permite que otros vean tu descripción en tu perfil público.</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-switch v-model="settings.showDescription" color="primary" hide-details class="mt-0 pt-0"></v-switch>
                      </v-list-item-action>
                    </v-list-item>

                    <v-divider class="my-2 opacity-50"></v-divider>

                    <v-list-item class="px-0 hover-bg rounded-lg transition-all mb-2">
                      <v-list-item-avatar class="primary-light-bg rounded-lg">
                        <v-icon color="primary">mdi-cake-variant-outline</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium primary-text">Mostrar Fecha de Nacimiento</v-list-item-title>
                        <v-list-item-subtitle class="text-caption grey--text">Haz pública tu fecha de cumpleaños.</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-switch v-model="settings.showNacimiento" color="primary" hide-details class="mt-0 pt-0"></v-switch>
                      </v-list-item-action>
                    </v-list-item>

                    <v-divider class="my-2 opacity-50"></v-divider>

                    <v-list-item class="px-0 hover-bg rounded-lg transition-all">
                      <v-list-item-avatar class="primary-light-bg rounded-lg">
                        <v-icon color="primary">mdi-ring</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium primary-text">Mostrar Estado Civil</v-list-item-title>
                        <v-list-item-subtitle class="text-caption grey--text">Incluye tu estado civil en tu perfil público.</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-switch v-model="settings.showEstadoCivil" color="primary" hide-details class="mt-0 pt-0"></v-switch>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </div>
              </v-card>
            </v-col>

            <!-- Columna Secundaria: Preferencias de Publicaciones e Intereses -->
            <v-col cols="12" md="6">
              <v-card class="glass-card rounded-xl mb-4" elevation="10">
                <div class="pa-6">
                  <div class="d-flex align-center mb-6">
                    <v-icon color="secondary" class="mr-3">mdi-post-outline</v-icon>
                    <h2 class="text-h6 font-weight-bold primary-text mb-0">Publicaciones</h2>
                  </div>
                  
                  <v-list-item class="px-0 hover-bg rounded-lg transition-all mb-2">
                    <v-list-item-avatar class="secondary-light-bg rounded-lg">
                      <v-icon color="secondary">mdi-eye-outline</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium primary-text">Ver Todas las Publicaciones</v-list-item-title>
                      <v-list-item-subtitle class="text-caption grey--text">Muestra todo el contenido, sin filtrar por intereses.</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-switch v-model="settings.showAll" color="secondary" hide-details class="mt-0 pt-0"></v-switch>
                    </v-list-item-action>
                  </v-list-item>
                </div>
              </v-card>

              <!-- Intereses -->
              <v-expand-transition>
                <v-card v-if="!settings.showAll" class="glass-card rounded-xl" elevation="10">
                  <div class="pa-6">
                    <div class="d-flex align-center mb-4">
                      <v-icon color="info" class="mr-3">mdi-star-circle-outline</v-icon>
                      <h2 class="text-h6 font-weight-bold primary-text mb-0">Intereses</h2>
                    </div>
                    <p class="text-caption grey--text text--darken-1 mb-4">Selecciona las categorías de publicaciones que te gustaría ver en tu muro.</p>
                    
                    <v-list class="transparent-bg pa-0 list-scroll">
                      <v-list-item v-for="(category, index) in allCategories" :key="index" class="px-2 py-1 hover-bg rounded-lg transition-all mb-1 border-light">
                        <v-list-item-action class="mr-3">
                          <v-checkbox v-model="selected" :value="category.id" color="info" hide-details class="mt-0 pt-0"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-medium text-body-2 primary-text">{{ category.name }}</v-list-item-title>
                          <v-list-item-subtitle class="text-caption grey--text">{{ category.tags }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </div>
                </v-card>
              </v-expand-transition>
            </v-col>
          </v-row>

          <div class="d-flex justify-end mt-6">
            <v-btn
              color="success"
              rounded
              class="custom-btn-shadow font-weight-bold px-8 text-none"
              large
              @click="save()"
            >
              <v-icon left>mdi-content-save-outline</v-icon>
              Guardar Ajustes
            </v-btn>
          </div>
        </div>

      </v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Nota",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
    
  },

  data: () => ({
    title:"Configuración",
    settings:{},
    allCategories:[],
    selected:[]
  }),
  mounted() {
    this.$API
      .get({
        url: "alumno/getAlumno"
      }).then((res) => {
        console.log(res)
        this.settings=res.settings;
        this.selected = res.categories.map((v) => {return v.category_id})
        
      });
    this.$API
      .get({
        url: "publications-categories"
      }).then((res) => {
        this.allCategories=res;
       
        
      });
  },
  methods: {
    async save(){
      var formData = new FormData();
      formData.append('settings',JSON.stringify(this.settings));
      formData.append('categories', this.selected )
      
       await this.$API
        .post({
          url: "profile",
          data: formData
        }).then(res => {
            this.selected = res.categories.map((v) => {return v.category_id})
        });
    }
  }
};
</script>

<style scoped>
/* Glassmorphism Classes (Premium UI) */
.settings-container { background: transparent !important; min-height: calc(100vh - 120px); }
.glass-panel { background: rgba(255, 255, 255, 0.7) !important; backdrop-filter: blur(16px) !important; border: 1px solid rgba(255, 255, 255, 0.5) !important; box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05) !important; border-radius: 20px; padding: 24px; }
.glass-card { background: rgba(255, 255, 255, 0.85) !important; backdrop-filter: blur(16px) !important; border: 1px solid rgba(255, 255, 255, 0.4) !important; }
.glass-btn { background: rgba(25, 118, 210, 0.1) !important; backdrop-filter: blur(4px) !important; box-shadow: none !important; transition: all 0.3s ease; }
.glass-btn:hover { background: rgba(25, 118, 210, 0.2) !important; transform: translateY(-2px); }
.transparent-bg { background: transparent !important; }

/* Utilities */
.primary-text { color: #1e293b; }
.opacity-30 { opacity: 0.3; }
.opacity-50 { opacity: 0.5; }
.w-100 { width: 100%; }
.h-100 { height: 100%; }
.transition-all { transition: all 0.3s ease; }

/* Custom elements */
.primary-light-bg { background-color: rgba(25, 118, 210, 0.08) !important; }
.secondary-light-bg { background-color: rgba(156, 39, 176, 0.08) !important; }
.hover-bg:hover { background-color: rgba(0, 0, 0, 0.02) !important; }
.border-light { border: 1px solid rgba(0, 0, 0, 0.03) !important; }
.list-scroll { max-height: 350px; overflow-y: auto; }

/* Scrollbar for list */
.list-scroll::-webkit-scrollbar { width: 6px; }
.list-scroll::-webkit-scrollbar-track { background: transparent; }
.list-scroll::-webkit-scrollbar-thumb { background-color: rgba(0, 0, 0, 0.1); border-radius: 10px; }
.list-scroll::-webkit-scrollbar-thumb:hover { background-color: rgba(0, 0, 0, 0.2); }

.custom-btn-shadow { box-shadow: 0 8px 20px -6px rgba(76, 175, 80, 0.4) !important; transition: all 0.3s ease; height: 48px !important; }
.custom-btn-shadow:hover { transform: translateY(-2px); box-shadow: 0 12px 25px -6px rgba(76, 175, 80, 0.5) !important; }
</style>
